import React, { useEffect, useState } from 'react';
import { useParams, Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './Auth.css';

const EmailVerificationResult = () => {
  const { uidb64, token } = useParams();
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

  // Appliquer la langue depuis l'URL (?lang=) si présente
  useEffect(() => {
    const lang = searchParams.get('lang');
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [searchParams, i18n]);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${API_URL}/auth/verify-email/${uidb64}/${token}/`);
        setStatus('success');
        setMessage(response.data.message || t('emailVerification.successMessage'));
      } catch (error) {
        setStatus('error');
        setMessage(
          error.response?.data?.error ||
          error.response?.data?.message ||
          t('emailVerification.errorMessage')
        );
      }
    };

    if (uidb64 && token) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage(t('emailVerification.missingParams'));
    }
  }, [uidb64, token, API_URL]);

  return (
    <div className="auth-container">
      <div className="auth-main auth-main-no-nav">
        <div className="auth-content-wrapper">
          <div className="auth-card">
            <div style={{ textAlign: 'center' }}>
              {status === 'loading' && (
                <>
                  <div style={{ fontSize: '64px', marginBottom: '20px' }}>⏳</div>
                  <h1 style={{ color: '#333', marginBottom: '15px' }}>
                    {t('emailVerification.loading')}
                  </h1>
                  <p style={{ color: '#666' }}>{t('emailVerification.pleaseWait')}</p>
                </>
              )}

              {status === 'success' && (
                <>
                  <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
                  <h1 style={{ color: '#28a745', marginBottom: '15px' }}>
                    {t('emailVerification.success')}
                  </h1>
                  <p style={{ color: '#666', marginBottom: '30px', fontSize: '16px' }}>
                    {message}
                  </p>
                  <Link
                    to="/login"
                    style={{
                      display: 'inline-block',
                      padding: '12px 24px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '5px',
                      fontWeight: '600',
                      fontSize: '16px',
                      transition: 'transform 0.2s'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    {t('emailVerification.loginNow')}
                  </Link>
                </>
              )}

              {status === 'error' && (
                <>
                  <div style={{ fontSize: '64px', marginBottom: '20px' }}>❌</div>
                  <h1 style={{ color: '#dc3545', marginBottom: '15px' }}>
                    {t('emailVerification.error')}
                  </h1>
                  <p style={{ color: '#666', marginBottom: '30px', fontSize: '16px' }}>
                    {message}
                  </p>
                  <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link
                      to="/login"
                      style={{
                        display: 'inline-block',
                        padding: '12px 24px',
                        background: 'transparent',
                        color: '#667eea',
                        border: '2px solid #667eea',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        fontWeight: '600',
                        fontSize: '16px'
                      }}
                    >
                      {t('emailVerification.goToLogin')}
                    </Link>
                    <Link
                      to="/signup"
                      style={{
                        display: 'inline-block',
                        padding: '12px 24px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        fontWeight: '600',
                        fontSize: '16px'
                      }}
                    >
                      {t('emailVerification.createAccount')}
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationResult;
